// import Vue from 'vue'
import { Collection, Model } from '..'
import Enhancer from '../Enhancer'
// import { Query } from '@/modules/plugins/query'
// import store from '@/modules/store'
// import isEqual from 'lodash.isequal'

class TrackOrder extends Model {
    constructor(json, ...args) {
        super(...args)
        this.apiRoot = 'frontend-api'
        this.apiVersion = null
        this.apiBase = 'order'
        this._model = json
        return new Proxy(this, Enhancer)
    }
    fetch(id) {
        return super.fetch(id)
    }

    get deliveryJob() {
        return this._model.deliveryJob
    }

    set deliveryJob(val) {
        this._model.deliveryJob = val
    }
}

class TrackOrders extends Collection {
    constructor(...args) {
        super(...args)
        this.apiRoot = 'frontend-api'
        this.apiVersion = null
        this.apiBase = 'order/track-deliveries'
    }
}

export { TrackOrder, TrackOrders }
